// Gift Reggie Cart Integration
// This file handles the add to cart functionality for Gift Reggie products
// to open the cart drawer instead of redirecting to the cart page

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Gift Reggie cart functionality
  initGiftReggieCart();
});

function initGiftReggieCart() {
  // Find all Gift Reggie add to cart buttons
  const addToCartButtons = document.querySelectorAll('.giftreggie-add-to-cart');
  
  addToCartButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const variantRow = this.closest('.registry-variant');
      const variantId = variantRow.querySelector('.variant-id').value;
      const quantityInput = variantRow.querySelector('.registry-variant-quantity');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      if (quantity <= 0) {
        alert("Please enter a valid quantity.");
        return false;
      }
      
      // Add to cart using the same method as product-form.js
      addToCartDrawer(variantId, quantity, this);
    });
  });
}

function addToCartDrawer(variantId, quantity, button) {
  // Get cart drawer element
  const cart = document.querySelector('cart-drawer');
  
  if (!cart) {
    console.error('Cart drawer not found');
    // Fallback to cart page
    window.location = window.routes.cart_url;
    return;
  }
  
  // Check if cart drawer has required methods
  if (!cart.open) {
    console.error('Cart drawer open method not available');
    window.location = window.routes.cart_url;
    return;
  }
  
  // Disable button and show loading state
  button.disabled = true;
  button.classList.add('loading');
  const originalText = button.textContent;
  button.textContent = 'Adding...';
  
  // Prepare form data
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);
  
  // Don't request sections - we'll manually refresh the cart drawer
  
  // Prepare fetch config
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;
  
  // Make the request
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        // Handle error
        console.error('Add to cart error:', response.description);
        alert('Error adding item to cart: ' + response.description);
        return;
      }
      
      // Success - manually refresh cart drawer content
      try {
        // Fetch fresh cart data and update the drawer
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then(response => response.text())
          .then(html => {
            // Parse the HTML and extract just the cart drawer content
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const cartDrawerContent = doc.querySelector('#CartDrawer');
            
            if (cartDrawerContent) {
              // Update the cart drawer content
              const currentCartDrawer = document.querySelector('#CartDrawer');
              if (currentCartDrawer) {
                currentCartDrawer.innerHTML = cartDrawerContent.innerHTML;
              }
            }
            
            // Open the cart drawer
            cart.open();
          })
          .catch(error => {
            console.error('Error refreshing cart drawer:', error);
            // Fallback: just open the drawer
            cart.open();
          });
      } catch (error) {
        console.error('Error opening cart drawer:', error);
        // Fallback: redirect to cart page if drawer fails
        window.location = window.routes.cart_url;
      }
    })
    .catch((error) => {
      console.error('Add to cart error:', error);
      alert('Error adding item to cart. Please try again.');
    })
    .finally(() => {
      // Re-enable button and restore original text
      button.disabled = false;
      button.classList.remove('loading');
      button.textContent = originalText;
    });
}

// Helper function to get fetch config (same as in global.js)
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
} 